import React from 'react';
import PropTypes from 'prop-types';
import { sendAnalytics } from '@audio-network/analytics';
import * as Styled from './TrackDetails.styles';
import { getComposerUrl } from '../../utils';
import getTrackUrl from '../../utils/getTrackUrl';
import Marquee from '../Marquee/Marquee';
var TrackDetails = function TrackDetails(_ref) {
  var _currentTrack$compose;
  var currentTrack = _ref.currentTrack;
  var isSoundEffect = (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.type) === 'sound-effect';
  var handleTrackClick = function handleTrackClick() {
    sendAnalytics(null, 'Player', 'Track Clicked', {
      TrackId: currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.id,
      TrackTitle: currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.title
    });
  };
  var handleComposerClick = function handleComposerClick(composer) {
    sendAnalytics(null, 'Player', 'Artist Clicked', {
      ArtistId: composer.id,
      ArtistName: composer.name
    });
  };
  var linkedComposers = (currentTrack === null || currentTrack === void 0 ? void 0 : (_currentTrack$compose = currentTrack.composers) === null || _currentTrack$compose === void 0 ? void 0 : _currentTrack$compose.length) > 0 && (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.composers.map(function (composer, index) {
    var _composer$firstName, _composer$id;
    return [index > 0 && ' | ', /*#__PURE__*/React.createElement(Styled.Composer, {
      as: isSoundEffect ? 'span' : 'a',
      key: "".concat((_composer$firstName = composer.firstName) !== null && _composer$firstName !== void 0 ? _composer$firstName : composer.lastName, "-").concat((_composer$id = composer.id) !== null && _composer$id !== void 0 ? _composer$id : index),
      target: isSoundEffect ? null : '_parent',
      href: isSoundEffect ? null : getComposerUrl(composer),
      onClick: isSoundEffect ? null : function () {
        return handleComposerClick(composer);
      }
    }, composer.lastName)];
  }));
  return /*#__PURE__*/React.createElement(Styled.DetailsContainer, {
    id: "player-track-details"
  }, (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.title) && /*#__PURE__*/React.createElement(Styled.TitleWrapper, {
    "data-testid": "player-track-title-wrapper"
  }, /*#__PURE__*/React.createElement(Marquee, {
    key: currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.title,
    delay: 2
  }, /*#__PURE__*/React.createElement(Styled.Title, {
    as: isSoundEffect ? 'span' : 'a',
    target: isSoundEffect ? null : '_parent',
    href: isSoundEffect ? null : getTrackUrl(currentTrack),
    onClick: isSoundEffect ? null : handleTrackClick
  }, currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.title))), !(currentTrack !== null && currentTrack !== void 0 && currentTrack.title) && (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.description) && /*#__PURE__*/React.createElement(Styled.TitleWrapper, {
    "data-testid": "player-track-title-wrapper"
  }, /*#__PURE__*/React.createElement(Marquee, {
    key: currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.description,
    delay: 2
  }, /*#__PURE__*/React.createElement(Styled.Title, null, currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.description))), (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.composers) && /*#__PURE__*/React.createElement(Styled.Composers, {
    "data-testid": "player-track-composer-wrapper"
  }, linkedComposers));
};
TrackDetails.propTypes = {
  currentTrack: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
    composers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      collectionSociety: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      ipi: PropTypes.string,
      name: PropTypes.string
    })),
    type: PropTypes.string
  })
};
TrackDetails.defaultProps = {
  currentTrack: {
    id: null,
    title: null,
    description: null,
    composers: null
  }
};
export default TrackDetails;